import {useQuery} from '@tanstack/react-query';
import {apiClient} from '../../../../lib/api-client';

export const useGetResourceGuides = () => {

	const { data, isLoading } = useQuery({
		queryKey: ['resource-guides'],
		queryFn: async () => await apiClient.get('document/resource-guides') as any[]
	});

	return {
		data,
		isLoading
	};
};
